import React from 'react';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate();

  // Function to handle messages from the iframe
  const handleMessage = React.useCallback((event) => {
    // If the message is to navigate to a particular route
    if (event.data && event.data.route) {
      navigate(event.data.route);
    }
  }, [navigate]);

  // Add event listener for messages from iframe
  React.useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [handleMessage]);

  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe 
        src="/app/landing/index.html" 
        title="Landing Page"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          overflow: 'hidden'
        }}
      />
    </div>
  );
};

export default LandingPage;
